import { InjectionToken } from '@angular/core';
import type { TimelineEvent, TimelineEventType } from '../../features/variance-tracker/components/variance-supporting-data/models/timeline-event.model';

//NOTE: THis is for testing purposes with the mock data, once the api is implemented this service could be removed
/**
 * Contract for adding a Feature Comparison as an incident on a case.
 * Used by Feature Comparison when user confirms "Add as incident", and by
 * Case Investigation mock to include those rows in the table.
 */
/** Optional payload for the added incident row (e.g. medication and employee from Feature Comparison). */
export interface AddComparisonAsIncidentPayload {
  medication?: string;
  employeeName?: string;
}

export interface AddComparisonTimelinePayload {
  eventType: TimelineEventType;
  message: string;
  incidentRowId?: string | null;
}

export interface AddComparisonAsIncidentClient {
  /** Register a new incident row for the given case (e.g. from Feature Comparison page). */
  addComparisonAsIncident(caseId: string, rowId: string, payload?: AddComparisonAsIncidentPayload): void;
  /** Return row ids that were added for this case (for mock table merge). */
  getAddedIncidentRowIds(caseId: string): readonly string[];
  /** Return payload for an added row (medication, employeeName) for display on case investigation. */
  getAddedIncidentRowPayload(caseId: string, rowId: string): AddComparisonAsIncidentPayload | undefined;
  /** Register a synthetic timeline event used when API timeline persistence is unavailable. */
  addSyntheticTimelineEvent(caseId: string, payload: AddComparisonTimelinePayload): void;
  /** Return synthetic timeline events for a case, newest first. */
  getSyntheticTimelineEvents(caseId: string): readonly TimelineEvent[];
}

export const ADD_COMPARISON_AS_INCIDENT_CLIENT = new InjectionToken<AddComparisonAsIncidentClient>(
  'ADD_COMPARISON_AS_INCIDENT_CLIENT'
);
